import Vue from "vue";
import router from "@/router/config.js";
import { Notification  } from "element-ui";

const common = {
    state: {
        view: true,
        headView: true,
        mainView: true,
        showAIPopup: {
          state: false,
          pojo: '',
          field: '',
          question: '',
        },
        contentByAI: {
          content: '',
          field: '',
        },
    },
    mutations: {
      SHOW_AI_POPUP(state, showAIPopup) {
        state.showAIPopup = showAIPopup;
      },
      CONTENT_BY_AI(state, contentByAI) {
        state.contentByAI = contentByAI;
      },
    },
    actions: {
        logout(store) {
            var request = {
                url: "logout"
            };
            store.dispatch("server", request).then((response) => {
                if (response.data.code == 200) {
                    localStorage.clear();
                    router.go();
                } else {
                    Notification.error(response.data.msg);
                }
            });
        },
        updateUserInfo(store) {
            var request = {
                url: "updateUser"
            };
            store.dispatch("server", request).then((response) => {
                if (response.data.code == 200) {
                    localStorage.setItem("userInfo", JSON.stringify(response.data.data));
                    store.dispatch("reloadView");
                } else {
                    Notification.error(response.data.msg);
                }
            });
        },
        reloadView(store) {
            store.state.view = false;
            Vue.nextTick(() => {
                store.state.view = true;
            });
        },
        reloadHeadView(store) {
            store.state.headView = false;
            Vue.nextTick(() => {
                store.state.headView = true;
            });
        },
        reloadMainView(store) {
            store.state.mainView = false;
            Vue.nextTick(() => {
                store.state.mainView = true;
            });
        }
    }
};

export default common;



// WEBPACK FOOTER //
// ./src/store/modules/common.js